<div class="create-circuit">
  <div class="loader" *ngIf="isLoading">
    <app-loading-spinner></app-loading-spinner>
  </div>
  <div class="header-create">
    <div class="title">
      {{ pageTitle }}
    </div>
    <div class="subtitle">
      Étape 3 / 5
    </div>
  </div>
  <div class="breadcrumb">
    <li>
      <a style="cursor:pointer;" (click)="savePointThenChange('direct', 1)" class="done">
        Information sur le circuit >
      </a>
    </li>
    <li>
      <a style="cursor:pointer;" (click)="savePointThenChange('direct', 2)" class="done">
        Ajoutez vos points >
      </a>
    </li>
    <li>
      <a style="cursor:pointer;" class="active">
        Configurez vos points >
      </a>
    </li>
    <li>
      <a style="cursor:pointer;" (click)="savePointThenChange('direct', 4)" [ngClass]="{'disabled' : !checkAllDone}">
        Vérifiez vos points >
      </a>
    </li>
    <li>
      <a style="cursor:pointer;" (click)="savePointThenChange('direct', 5)" [ngClass]="{'disabled' : !checkAllDone}">
        Validation
      </a>
    </li>
  </div>
  <div class="content">
    <div class="point-list">
      <div class="point-number" *ngFor="let point of currentRoutePoints; let i = index" (click)="savePointThenChange(i)" [ngClass]="{'current' : currentPointEdit == i, 'notvalidated' : point.statut_edit == 0, 'validated' : point.statut_edit == 1}">
        <div class="point-name">
          {{ point.title }}
        </div>
        {{ i + 1 }}
      </div>
    </div>
    <div class="contenu" *ngFor="let point of currentRoutePoints; let i = index">
      <div class="content-current-point" *ngIf="currentPointEdit == i && googleInfos[currentPointEdit]">
        <div class="titles">
          <div class="google">
            Informations issues de Google
          </div>
          <div class="perso">
            Vos informations
          </div>
        </div>
        <div class="name">
          <div class="google">
            <div class="input-title">
              Nom du point
            </div>
            <div class="input">
              {{ googleInfos[currentPointEdit].title }}
            </div>
          </div>
          <div class="copy">
            <div class="icone" (click)="onCopyData(googleInfos[currentPointEdit].title, 'title', currentPointEdit)">
              <div class="triangle">
                <svg height="512pt" viewBox="-56 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m395.980469 112.582031-108.023438-108.023437c-2.960937-2.960938-6.949219-4.558594-11.019531-4.558594h-156.339844c-8.597656 0-15.578125 6.980469-15.578125 15.578125v89.445313h-89.441406c-8.597656 0-15.578125 6.976562-15.578125 15.578124v375.820313c0 8.597656 6.980469 15.578125 15.578125 15.578125h264.359375c8.601562 0 15.582031-6.980469 15.582031-15.578125v-89.445313h89.441407c8.597656 0 15.578124-6.976562 15.578124-15.578124v-267.796876c0-3.960937-1.523437-7.984374-4.558593-11.019531zm-26.597657 263.238281h-73.863281v-147.195312c0-4.035156-1.570312-8.03125-4.5625-11.023438l-108.019531-108.019531c-2.933594-2.9375-6.914062-4.5625-11.019531-4.5625h-35.738281v-73.863281h125.179687v92.445312c0 8.597657 6.980469 15.578126 15.578125 15.578126h92.445312zm-105.023437 105.023438h-233.203125v-344.664062h125.179688v92.445312c0 8.597656 6.980468 15.578125 15.582031 15.578125h92.441406zm-76.863281-322.636719 54.835937 54.835938h-54.835937zm159.855468-50.183593h-54.835937v-54.835938c6.855469 6.851562 49.367187 49.367188 54.835937 54.835938zm0 0"/></svg>
              </div>
            </div>
          </div>
          <div class="perso">
            <div class="input-title">
              Nom du point
            </div>
            <div class="input">
              <input
                type="text"
                placeholder="Nom du point"
                [(ngModel)]="titles[currentPointEdit]"
                />
            </div>
          </div>
        </div>
        <div class="description">
          <div class="google">
            <div class="input-title">
              Description
            </div>
            <div class="input textarea">
              {{ googleInfos[currentPointEdit].description }}
            </div>
          </div>
          <div class="copy center">
            <div class="icone" (click)="onCopyData(googleInfos[currentPointEdit].description, 'description', currentPointEdit)">
              <div class="triangle">
                <svg height="512pt" viewBox="-56 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m395.980469 112.582031-108.023438-108.023437c-2.960937-2.960938-6.949219-4.558594-11.019531-4.558594h-156.339844c-8.597656 0-15.578125 6.980469-15.578125 15.578125v89.445313h-89.441406c-8.597656 0-15.578125 6.976562-15.578125 15.578124v375.820313c0 8.597656 6.980469 15.578125 15.578125 15.578125h264.359375c8.601562 0 15.582031-6.980469 15.582031-15.578125v-89.445313h89.441407c8.597656 0 15.578124-6.976562 15.578124-15.578124v-267.796876c0-3.960937-1.523437-7.984374-4.558593-11.019531zm-26.597657 263.238281h-73.863281v-147.195312c0-4.035156-1.570312-8.03125-4.5625-11.023438l-108.019531-108.019531c-2.933594-2.9375-6.914062-4.5625-11.019531-4.5625h-35.738281v-73.863281h125.179687v92.445312c0 8.597657 6.980469 15.578126 15.578125 15.578126h92.445312zm-105.023437 105.023438h-233.203125v-344.664062h125.179688v92.445312c0 8.597656 6.980468 15.578125 15.582031 15.578125h92.441406zm-76.863281-322.636719 54.835937 54.835938h-54.835937zm159.855468-50.183593h-54.835937v-54.835938c6.855469 6.851562 49.367187 49.367188 54.835937 54.835938zm0 0"/></svg>
              </div>
            </div>
          </div>
          <div class="perso">
            <div class="input-title">
              Description
            </div>
            <div class="input">
              <textarea
                rows="4"
                placeholder="Description"
                [(ngModel)]="descriptions[currentPointEdit]"
                ></textarea>
            </div>
          </div>
        </div>
        <div class="moreinfos">
          <div class="google">
            <div class="input-title">
              Horaires
            </div>
            <div class="input textarea">
              {{ googleInfos[currentPointEdit].horaires }}
            </div>
          </div>
          <div class="copy center">
            <div class="icone" (click)="onCopyData(googleInfos[currentPointEdit].horaires, 'moreinfo', currentPointEdit)">
              <div class="triangle">
                <svg height="512pt" viewBox="-56 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m395.980469 112.582031-108.023438-108.023437c-2.960937-2.960938-6.949219-4.558594-11.019531-4.558594h-156.339844c-8.597656 0-15.578125 6.980469-15.578125 15.578125v89.445313h-89.441406c-8.597656 0-15.578125 6.976562-15.578125 15.578124v375.820313c0 8.597656 6.980469 15.578125 15.578125 15.578125h264.359375c8.601562 0 15.582031-6.980469 15.582031-15.578125v-89.445313h89.441407c8.597656 0 15.578124-6.976562 15.578124-15.578124v-267.796876c0-3.960937-1.523437-7.984374-4.558593-11.019531zm-26.597657 263.238281h-73.863281v-147.195312c0-4.035156-1.570312-8.03125-4.5625-11.023438l-108.019531-108.019531c-2.933594-2.9375-6.914062-4.5625-11.019531-4.5625h-35.738281v-73.863281h125.179687v92.445312c0 8.597657 6.980469 15.578126 15.578125 15.578126h92.445312zm-105.023437 105.023438h-233.203125v-344.664062h125.179688v92.445312c0 8.597656 6.980468 15.578125 15.582031 15.578125h92.441406zm-76.863281-322.636719 54.835937 54.835938h-54.835937zm159.855468-50.183593h-54.835937v-54.835938c6.855469 6.851562 49.367187 49.367188 54.835937 54.835938zm0 0"/></svg>
              </div>
            </div>
          </div>
          <div class="perso">
            <div class="input-title">
              Informations complémentaires <span>(horaires, prix, ...)</span>
            </div>
            <div class="input">
              <textarea
                rows="7"
                placeholder="Informations complémentaires"
                [(ngModel)]="moreinfos[currentPointEdit]"
                ></textarea>
            </div>
          </div>
        </div>
        <div class="images-youtube">
          <div class="google">
            <div class="title">
              Images
            </div>
            <div class="content" *ngIf="googleInfos[currentPointEdit].medias">
              <div class="image" *ngFor="let media of googleInfos[currentPointEdit].medias">
                <img src="{{media}}" alt="">
                <div class="copy" (click)="onCopyImage(media, $event)">
                  <svg class="to-copy" height="512pt" viewBox="-56 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m395.980469 112.582031-108.023438-108.023437c-2.960937-2.960938-6.949219-4.558594-11.019531-4.558594h-156.339844c-8.597656 0-15.578125 6.980469-15.578125 15.578125v89.445313h-89.441406c-8.597656 0-15.578125 6.976562-15.578125 15.578124v375.820313c0 8.597656 6.980469 15.578125 15.578125 15.578125h264.359375c8.601562 0 15.582031-6.980469 15.582031-15.578125v-89.445313h89.441407c8.597656 0 15.578124-6.976562 15.578124-15.578124v-267.796876c0-3.960937-1.523437-7.984374-4.558593-11.019531zm-26.597657 263.238281h-73.863281v-147.195312c0-4.035156-1.570312-8.03125-4.5625-11.023438l-108.019531-108.019531c-2.933594-2.9375-6.914062-4.5625-11.019531-4.5625h-35.738281v-73.863281h125.179687v92.445312c0 8.597657 6.980469 15.578126 15.578125 15.578126h92.445312zm-105.023437 105.023438h-233.203125v-344.664062h125.179688v92.445312c0 8.597656 6.980468 15.578125 15.582031 15.578125h92.441406zm-76.863281-322.636719 54.835937 54.835938h-54.835937zm159.855468-50.183593h-54.835937v-54.835938c6.855469 6.851562 49.367187 49.367188 54.835937 54.835938zm0 0"/></svg>
                  <svg class="copied" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 375.147 375.147" style="enable-background:new 0 0 375.147 375.147;" xml:space="preserve">
                  	<g>
                  		<g>
                  			<polygon points="344.96,44.48 119.147,270.293 30.187,181.333 0,211.52 119.147,330.667 375.147,74.667 		"/>
                  		</g>
                  	</g>
                  </svg>
                </div>
              </div>
            </div>
            <div class="no-content" *ngIf="!googleInfos[currentPointEdit].medias">
              Aucune image issue de Google
            </div>
          </div>
          <div class="perso">
            <div class="title">
              Images
            </div>
            <div class="subtitle">
              La première image constitue la bannière du point. Elle est obligatoire.
            </div>
            <div class="content">
              <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'" (change)="onSelect($event)">
                <ngx-dropzone-label>
                  <div class="label">Glissez ou cliquez pour déposer des images</div>
                </ngx-dropzone-label>
                <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files[currentPointEdit]" [file]="f" [removable]="true" (removed)="onRemove(f)">
                  <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
                </ngx-dropzone-image-preview>
              </div>
            </div>
            <div class="youtube">
              <div class="input-title">
                Vidéo youtube
              </div>
              <div class="input-subtitle">
                Vous pouvez ajouter une vidéo youtube qui se lance au clic sur la bannière.
              </div>
              <div class="input">
                <input
                  type="text"
                  placeholder="Lien de la vidéo Youtube"
                  [(ngModel)]="youtubes[currentPointEdit]"
                  />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="point-list end">
      <div class="point-number" *ngFor="let point of currentRoutePoints; let i = index" (click)="savePointThenChange(i)" [ngClass]="{'current' : currentPointEdit == i, 'notvalidated' : point.statut_edit == 0, 'validated' : point.statut_edit == 1}">
        <div class="point-name">
          {{ point.title }}
        </div>
        {{ i + 1 }}
      </div>
    </div>
  </div>
  <div class="boutons-change">
    <div class="bouton-prev">
      <a style="cursor:pointer;" (click)="savePointThenChange('prev')">
        << Revenir
      </a>
    </div>
    <div class="bouton-next">
      <a style="cursor:pointer;" (click)="savePointThenChange('next')">
        Suivant >>
      </a>
    </div>
  </div>
</div>
